import type { NotificationKind } from '@kanos/domain';

/** What concerns the client as a whole: a follow-up and a responsibility live at the client. */
const AT_CLIENT: readonly NotificationKind[] = ['responsible', 'follow-up'];

/** Whether a message leads to the GwG intake - its statements, screenings, documents, closing. */
export const opensIntake = (kind: NotificationKind) => !AT_CLIENT.includes(kind);

/**
 * Where a message about a client leads: news of the GwG intake to the intake, where it is
 * checked; a follow-up or a responsibility to the client's overview, where both live.
 */
export const messageTarget = (kind: NotificationKind, caseId: string) =>
  opensIntake(kind)
    ? ({ to: '/intakes/$caseId', params: { caseId } } as const)
    : ({ to: '/clients/$caseId', params: { caseId } } as const);
